import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterLink } from '@angular/router';
import { EquipmentRequestService } from '../../../../services/equipment-request/equipment-request.service';

interface EquipmentRequestSummary {
  employeeName: string;
  requestDate: string;
  _id: string;
  formStatus: string;
}
@Component({
    selector: 'app-it-form-hub',
    imports: [
        CommonModule,
        MatTableModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        RouterLink
    ],
    templateUrl: './it-form-hub.component.html',
    styleUrls: ['./it-form-hub.component.css']
})

export class ItFormHubComponent implements OnInit {
  displayedColumns: string[] = ['employeeName', 'requestDate', 'formLink', 'formStatus'];
  dataSource = new MatTableDataSource<EquipmentRequestSummary>([]);
  loading: boolean = true; 
  error: string | null = null; 

  constructor(private equipmentRequestService: EquipmentRequestService, private router: Router) {}

  ngOnInit(): void {
    this.loadAllITForms();
    this.dataSource.filterPredicate = this.customFilterPredicate();
  }

  loadAllITForms(): void {
    this.equipmentRequestService.findAllEquipmentRequests().subscribe(
      (response) => {
        const equipmentRequestData = response?.data || [];
        this.equipmentRequestService.findAllEquipmentRequests().subscribe(
          (listResponse) => {
            const sseLists = listResponse?.data || [];
            const listMap = new Map(
              sseLists.map((list: any) => [list.indexId, list._id]) 
            );
            equipmentRequestData.forEach((row: any) => {
              row.sseListId = listMap.get(row._id) || null;
              // row.formStatus = this.getIndexStatus(row); 
            });

            this.dataSource.data = equipmentRequestData;
            this.loading = false;
          },
          (listError) => {
            console.error('Error fetching sseList data:', listError);
            this.error = 'Failed to load SSE List data. Please try again later.';
            this.loading = false;
          }
        );
        },
        (error) => {
          console.error('Error fetching Equipment Request data:', error);
          this.error = 'Failed to load Equipment Request data. Please try again later.';
          this.loading = false;
        }
    );
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  customFilterPredicate(): (data: any, filter: string) => boolean {
    return (data, filter) => {
      return (
        data.section1.employeeName?.toLowerCase().includes(filter)  ||
        data.formStatus?.toLowerCase().includes(filter) ||
        data.section1.requestDate.includes(filter)
      );
    };
  }
}
